module.exports = __webpack_public_path__ + "static/media/Human_ZG3243_1440.86cefa71.jpeg";